module.exports = __webpack_public_path__ + "a768e7de/img/settings-ico.a214628d.svg";